import React, { Component } from 'react';
import Tools from '../../tools.js';
import API from '../../api';
import ListView from '../utils/ListView';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Loading from '../Loading';

class MemberApp extends React.Component {
    E_TYPE = {
        NO_FILTER: 0,
        FILTER: 1
    };
    DEFAULT_MAX = 20;

    constructor() {
        super();
        Tools.init();
        API.init(this);

        this.state = {
            ty: this.E_TYPE.NO_FILTER,
            sz: this.DEFAULT_MAX,
            list: [],
            page_max: 20,
            filter: null,
            list_index_min: 0,
            list_index_max: 20,
            page_index: 0,
            fields: [
                "會員編號",
                "會員暱稱",
                "會員性別",
                "會員年齡",
                "會員手機"
            ],
            isLoading: false
        };
        console.log(this.state);
        console.log("init");
        this.getData = this.getData.bind(this);
        this.onListViewClicked = this.onListViewClicked.bind(this);
        this.onDataUpdated = this.onDataUpdated.bind(this);
        //using set timeout to make setState working
        setTimeout(() => this.getData(), 0);
    }

    getData() {
        this.setState({ isLoading: true });
        console.log(this.state);
        //ty: 取得方式 (0=全會員, 1=篩選會員)
        //sz: 數量
        var tmpData = {
            ty: this.state.ty
        };
        // API.GetMembers(tmpData, this.onDataUpdated.bind(this));
        API.GetMembers(tmpData).
            then(this.onDataUpdated.bind(this));
    }

    onListViewClicked(index) {
        console.log(index);
        //location.href = "detail.html?tac="+index);
        let path = '/#/member/detail/' + index;
        // this.props.history.push(path);
        window.open(path);
    }

    onDataUpdated(data) {
        this.setState({ isLoading: false });
        // console.log(this.state);
        // console.log(this);
        if (data && data.data) {
            // console.log(data.length);
            const tmp = [];
            /* {
                "devID": "0",
                "bind": {
                    "p": {
                        "ct": "1459073151000",
                        "va": "886938172335"
                    },
                    "g": {
                        "ct": 0,
                        "va": ""
                    },
                    "fb": {
                        "ct": 0,
                        "va": ""
                    },
                    "l": {
                        "ct": 0,
                        "va": ""
                    }
                },
                "enable": "1",
                "last_login": "0",
                "created_at": "1459073134000",
                "accID": "AbBmEjXN",
                "points": "150",
                "info": {
                    "birthday": "1900-02-21",
                    "live_city": 2,
                    "birth_city": 2,
                    "education": 0,
                    "gender": 1,
                    "live_dist": 24,
                    "display_name": "豬豬",
                    "job": 0,
                    "email": "",
                    "birth_dist": 24
                }
            } */
            for (let index in data.data) {
                const tmpObj = data.data[index];
                // "會員編號",
                // "會員暱稱",
                // "會員性別",
                // "會員年齡",
                // "會員手機"

                // {
                //     accID:0,
                //     m_nick:"t1",
                //     m_gender:"female",
                //     m_age:10,
                //     m_mobile:"0900000000"
                // }
                tmp.push({
                    key: tmpObj.accID,
                    data: [
                        tmpObj.accID,
                        tmpObj.info.display_name,
                        Tools.getGenderStr(tmpObj.info.gender),
                        tmpObj.info.birth_dist,
                        tmpObj.bind.p.va
                    ]
                });
            }
            this.setState({
                list: tmp
            })
        }
    }
    render() {
        const { list, page_max, filter, list_index_min, list_index_max, fields, isLoading } = this.state,
            totalEntries = list.length,
            onListViewClicked = this.onListViewClicked;
        return (
            <div>
                <ListView list={list}
                    fields={fields}
                    title={"會員列表"}
                    onRowClicked={onListViewClicked}
                />
                <Loading isLoading={isLoading} />
            </div>
        );
    }
}

// ReactDOM.render(
//     React.createElement(MemberApp),
//     document.getElementById('root')
// );

const mapStateToProps = (state) => ({
    id: state.authReducer.id
})

const mapDispatchToProps = {

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(MemberApp))